import { NavLink } from "react-router-dom";
import styles from "./Navbar.module.css";

const Navbar = () => {
    return (
        <nav className={styles.navbar}>
            <h2 className={styles.logo}>Downstream Dashboard</h2>
            <div className={styles.navLinks}>
                <NavLink
                    to="/"
                    className={({ isActive }) =>
                        `${styles.navItem} step-overview-2 ${isActive ? styles.active : ""}`
                    }
                >
                    Overview
                </NavLink>

                <NavLink
                    to="/comparison"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Comparison
                </NavLink>

                <NavLink
                    to="/individuals"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Individuals
                </NavLink>
                
                <NavLink
                    to="/trend"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Trend
                </NavLink>

                <NavLink
                    to="/data"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Data
                </NavLink>

                <NavLink
                    to="/feedback"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Feedback
                </NavLink>
            </div>

        </nav>
    );
};

export default Navbar;